<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card>
      <v-form lazy-validation @submit.prevent="submit" ref="form">
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col class="py-0" md="4" cols="12">
                <v-text-field
                  class="pa-0"
                  dense
                  label="Data Assinatura"
                  outlined
                  v-mask="'##/##/####'"
                  placeholder="00/00/0000"
                  v-model="formData.data_assinatura"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" md="4" cols="12">
                <v-text-field
                  class="pa-0"
                  dense
                  label="Data Início"
                  outlined
                  v-mask="'##/##/####'"
                  placeholder="00/00/0000"
                  v-model="formData.data_inicio"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" md="4" cols="12">
                <v-text-field
                  class="pa-0"
                  dense
                  label="Data Término"
                  outlined
                  v-mask="'##/##/####'"
                  placeholder="00/00/0000"
                  v-model="formData.data_fim"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" cols="12">
                <v-radio-group v-model="formData.veiculos" row>
                  <template v-slot:label>
                    <div>Apresentar Veículos?</div>
                  </template>
                  <v-radio label="Sim" value="S"></v-radio>
                  <v-radio label="Não" value="N"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn depressed :loading="isloadingSubmit" color="green" dark type="submit">
            <v-icon small left>mdi-send</v-icon>
            Buscar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <PDF />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';
import relatoriosHttp from '@/services/http/resources/configuracao/relatoriosHttp';
import toastMessage from '@/services/util/alertService';
import { mask } from 'vue-the-mask';

export default {
  name: 'RelatorioVeiculos',
  directives: {
    mask,
  },
  components: {
    PDF,
  },
  metaInfo: {
    title: 'Relatórios de Contratos',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Relatórios de Contratos',
    formData: {
      data_assinatura: '',
      data_inicio: '',
      data_fim: '',
      veiculos: 'N',
    },
    isloadingSubmit: false,
  }),
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
    submit() {
      this.isloadingSubmit = true;
      relatoriosHttp
        .contratos(this.formData)
        .then(({ data }) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          this.toggleModalPdf(fileURL);
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar documento.'))
        .finally(() => {
          this.isloadingSubmit = false;
        });
    },
  },
};
</script>

<style></style>
